NtechApp.ReloadOnScrollLocker = function($item) {
    var me = this;

    this._$item = null;
    this._uid = null;

    this._startY = null;
    this._prevY = null;

    this._disableLock = false;

    this._construct = function () {
        me._$item = $item;
        me._uid = ++NtechApp.ReloadOnScrollLocker.NEXT_EVENT_UID;

        me._bindEvents();
    };

    this._bindEvents = function () {
        me._$item.on(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHSTART + me._uid, function(event) {
            if(me._disableLock)
                return;

            me._bindTouchMoveEvent(event);
        });

        me._$item.on(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHEND + me._uid, function(event) {
            me._unbindTouchMoveEvent(event);
        });
    };

    this._bindTouchMoveEvent = function(event) {
        var y = event.originalEvent.touches[0].clientY;
        me._startY = me._prevY = y;

        var visibleHeight = NtechApp.getVisibleHeight(me._$item); 
        var contentHeight = me._$item.get(0).scrollHeight;
        var maxScrollTop = contentHeight - visibleHeight;

        // Touch-scroll start from top of scrollable item
        if(me._$item.scrollTop() == 0 && maxScrollTop == 0) {
            me._$item.on(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHMOVE + me._uid, function(event) {
                event.preventDefault();
            });
            return;
        }

        // Touch-scroll start from top of scrollable item with offset
        if(me._$item.scrollTop() <= 0) {
            me._$item.on(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHMOVE + me._uid, function(event) {
                me._lockScroll(event);
            });
        }
        // Touch scroll start from bottom of item
        else {
            if(me._$item.scrollTop() >= maxScrollTop) {
                me._$item.on(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHMOVE + me._uid, function(event) {
                    me._lockBottomScroll(event);
                });
            }
        }
    };

    this._unbindTouchMoveEvent = function(event) {
        me._$item.off(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHMOVE + me._uid);
    };

    this._unbindEvents = function () {
        ;
    };

    this.destruct = function () {
        me._unbindEvents();
    };

    this._construct();
    return this;
};

NtechApp.ReloadOnScrollLocker.NEXT_EVENT_UID = 0;
NtechApp.ReloadOnScrollLocker.EVENT_TOUCHSTART = "touchstart.NtechApp.ReloadOnScrollLocker";
NtechApp.ReloadOnScrollLocker.EVENT_TOUCHEND = "touchend.NtechApp.ReloadOnScrollLocker";
NtechApp.ReloadOnScrollLocker.EVENT_TOUCHMOVE = "touchmove.NtechApp.ReloadOnScrollLocker";

NtechApp.proto(NtechApp.ReloadOnScrollLocker, {
    _lockScroll: function(event) {
        var newY = event.originalEvent.touches[0].clientY; 
        if(this._prevY < newY) {
            event.preventDefault();
        }
        else if(this._startY >= newY) {
            this._unbindTouchMoveEvent();
        }

        this._prevY = newY;
    },

    _lockBottomScroll: function(event) {
        var newY = event.originalEvent.touches[0].clientY;
        if(this._prevY > newY)
            event.preventDefault();
        else if(this._startY <= newY)
            this._unbindTouchMoveEvent();

        this._prevY = newY;
    },

    disableLock: function() {
        this._disableLock = true;
    },

    enableLock: function() {
        this._disableLock = false;
    },

    destroy: function() {
        this._$item.off(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHSTART + this._uid);
        this._$item.off(NtechApp.ReloadOnScrollLocker.EVENT_TOUCHEND + this._uid);
    }
});